import type { OrganizationLighthouse } from '@ankor-io/common/types/account'

/**
 * Gets the display description for an organization.
 * Returns a default placeholder description if the organization's description
 * is missing or uses a default/placeholder value.
 *
 * @param organization - The organization object (can be undefined)
 * @returns The description to display
 */
export function getOrganizationDisplayDescription(organization: OrganizationLighthouse | undefined): string {
  const defaultDescription =
    "Manage your organization settings, feature toggles, and pricing configurations. Configure global defaults that apply across your organization or customize settings for specific use cases. Monitor user access and control visibility to streamline your team's workflow."

  if (
    !organization?.description ||
    organization.description === 'Default organization' ||
    organization.description === 'Description'
  ) {
    return defaultDescription
  }

  return organization.description
}
